export default __webpack_public_path__ + "static/media/something-else.a190ef8a.svg";